import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { firstValueFrom, map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { WSResponseModel } from '../classes/WSResponseModel';

@Injectable({
  providedIn: 'root'
})
export class MailingService {

  private baseURL = environment.crmURL;

  constructor(public http: HttpClient) { }

  private getHeaders(): { headers: HttpHeaders } {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'idAzienda': 'AZD0000000001',
        'emailAzienda': environment.backend.EmailFrom
      })
    };
  }

  async unsubscribe(email: string, motivo?: string, source?: string): Promise<WSResponseModel> {
    const body = {
      Email: email,
      Motivo: motivo ?? '',
      Source: source ?? ''
    };

    return await firstValueFrom(this.http.post<WSResponseModel>(
        `${this.baseURL}/api/Mailing/Unsubscribe`,
        body,
        this.getHeaders()
      ))
    .then(
      res=>{
        return res
      }
    ).catch(
      error => {
        console.log(error)  
        return error;
      }
    );
  }
}